export enum SyncStatuses {
  ItemMatches = 0,
  StandardConfigNoLongerHasItem = 1,
  StandardConfigHasNewItem = 2,
  SourceDiffers = 4,
  QuantityDiffers = 8,
  RateDiffers = 16,
  SourceAndQuantityDiffers = SourceDiffers | QuantityDiffers,
  SourceAndRateDiffers = SourceDiffers | RateDiffers,
  QuantityAndRateDiffers = QuantityDiffers | RateDiffers,
  SourceQuantityAndRateDiffers = SourceDiffers | QuantityDiffers | RateDiffers,
  MatchesNewScopingScreenItem = 32,
  MatchesNewStandardConfigItem = 64,
  ItemInactive = 128
}